import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isDriverHiddenSidebarRoute, getLayoutOutletKey } from '../../routes';
import Sidebar from './Sidebar';
import Header from './Header';
import { LayoutContainer, MainContent, ContentArea } from './styles';

const DRIVER_ROLE = 'ROLE_DRIVER';

/** Conteúdo da área principal vem das rotas filhas (Outlet). */
export default function Layout() {
    const { pathname } = useLocation();
    const { user } = useAuth();
    const userRoles = user?.roles || [];
    const isDriver = userRoles.includes(DRIVER_ROLE);
    const hideSidebar = isDriver && isDriverHiddenSidebarRoute(pathname);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        setMenuOpen(false);
    }, [pathname]);

    return (
        <LayoutContainer>
            {!hideSidebar && <Sidebar />}
            {hideSidebar && (
                <Sidebar
                    asDrawer
                    open={menuOpen}
                    onClose={() => setMenuOpen(false)}
                />
            )}
            <MainContent $fullWidth={hideSidebar}>
                <Header
                    showMenuButton={hideSidebar}
                    onMenuClick={() => setMenuOpen(true)}
                />
                <ContentArea $compact={hideSidebar}>
                    <Outlet key={getLayoutOutletKey(pathname)} />
                </ContentArea>
            </MainContent>
        </LayoutContainer>
    );
}
